/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { IAgentPlugin, IPluginMethodMap } from '@vlinder-web/plugin-agent-service-react';
import notification from '../config/notifications.config.json';
import axios from 'axios';

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { BULK_APPROVE } from '../graphql';
import { VApplication } from '../../../application';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IBulkApproveMethods extends IPluginMethodMap {
  getBulkApprove(args: any): Promise<any>;
}

export interface BulkApproveProps {
  emails: string[];
}

export class BulkApproveService implements IAgentPlugin {
  readonly methods: IBulkApproveMethods;

  constructor() {
    this.methods = {
      getBulkApprove: this.getBulkApprove.bind(this),
    };
  }

  async getBulkApprove(args: BulkApproveProps) {
    console.log(args, 'args in bulk approve');
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    try {
      if (client) {
        const res = await client.mutate({
          mutation: BULK_APPROVE,
          variables: {
            input: {
              userEmails: args,
            },
          },
          fetchPolicy: 'no-cache',
        });
        // if (res?.data?.BulkApprove?.message) {
        //   return {
        //     notification: 'The bulk approval request has been initiated. This may take a few minutes to complete.',
        //     // notification: notification?.BulkApprove,
        //   };
        // }
      }
    } catch (err: any) {
      console.log('error in revoke credential', err?.message);
      throw err;
    }
  }
}
